import { atom } from "jotai";

export const userVariablesAtom = atom<string[]>();
